import { Box, Flex, Text } from "@reverb-ui/react";
import React from "react";
import ContentNotFoundIcon from "@/assets/images/oh-dang-error.svg";
import { useTranslation } from "react-i18next";
export var ContentNotFound = function () {
    var t = useTranslation("home").t;
    return (React.createElement(Flex, { w: "full", justifyContent: "center" },
        React.createElement(Box, { justifyContent: "center" },
            React.createElement(ContentNotFoundIcon, null),
            React.createElement(Text, { textAlign: "center" }, t("content-not-found")))));
};
